import { isPlatformBrowser } from '@angular/common';
import { FamilyService } from './services/family/family.service';
import { OrdersService } from './services/order/orders.service';
import { PdvService } from './services/pdv/pdv.service';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  ourAppEvent;
  orderProg;
  alert = "";
  @ViewChild("template") template: ElementRef;
  bsModalRef: BsModalRef;
  constructor(
    private router: Router,
    private pdvService: PdvService,
    private ordersService: OrdersService,
    private familyService: FamilyService,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
    private meta: Meta,
    private modalService: BsModalService
  ) {
    this.ordersService.ourAppEvent.subscribe(
      data => {
        this.ourAppEvent = data;
      }
    )
    const subs8 = this.ordersService.orderProg.subscribe((orderProg) => {
      this.orderProg = orderProg;
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        if ((<any>window).ga) {
          (<any>window).ga('set', 'page', evt.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
        window.scrollTo(0, 0);
      }
    });
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });
    this.pdvService.getModesByPdv().subscribe(
      (data: any[]) => {
        this.pdvService.orderTypes.next(data);
        if (data.length > 0) {
          this.ordersService.orderType.next(data[0].id);
        }
      }
    );
    this.pdvService.getPdvInfo().subscribe(
      (data: any) => {
        this.pdvService.nbrOffersAuthorizedSite.next(data.nbrOffersAuthorizedSite);
        this.pdvService.pdv.next(data);
        this.ordersService.amountMiniDelivery.next(data.amountMiniOrder);
        this.ordersService.enablePayement.next(data.enablePayement);
        this.titleService.setTitle(data.name + " livre à domicile et au bureau");
        this.meta.addTag({ name: 'description', content: "Votre restaurant " + data.name + " vous livre à domicile et au bureau vos plats préférés. Commandez en ligne facilement. Site web réalisé par Helpyfood" });
        this.meta.addTag({ name: 'keywords', content: "livraison pizza, pizza livraison, livraison " + data.city + ", commander pizza en ligne, pizza, livraison à domicile, livraison " + data.name + ", livraison gratuite, burger, pizzas, site commander pizza, pizza à domicile, pizzeria " + data.city + ", commander à emporter, pizza emporter, pizzas, livraison nourriture, numéro pizzeria, livreur de pizza, commander une pizza" })
        if (this.getMobileOperatingSystem() == 'android') {
          if (data.android) {
            this.ordersService.ourAppEvent.next(true);
          }
        } else if (this.getMobileOperatingSystem() == 'iPhone') {
          if (data.ios) {
            this.ordersService.ourAppEvent.next(true);
          }
        }
        if (isPlatformBrowser(this.platformId)) {
          if (data.alert) {
            this.alert = data.alert;
            this.bsModalRef = this.modalService.show(this.template, {
              class: "ordertype-modal modal2-header"
            });
          }
          if (data.analytic) {
            this.loadAnalytic(data.analytic);
          }
        }
      }
    )
    this.familyService.getFamiliesOfCarte().subscribe(
      (families: any[]) => {

        let fa = families.sort(
          (a, b) => {
            if (a.order === null) {
              return 1;
            }
            else if (b.order === null) {
              return -1;
            }
            if (Number(a.order) > Number(b.order)) {
              return 1;
            }
            if (Number(a.order) < Number(b.order)) {
              return -1;
            }
            return 0;
          }
        );
        this.familyService.families.next(fa);
      })
    this.familyService.getMenuCategoriesOfCarte().subscribe(
      (menucategories: any[]) => {
        let categories = menucategories.sort(
          (a, b) => {
            if (a.order === null) {
              return 1;
            }
            else if (b.order === null) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            if (a.order < b.order) {
              return -1;
            }
            return 0;
          }
        );
        this.familyService.menucategories.next(categories);
      }
    )
  }
  getMobileOperatingSystem() {
    if (isPlatformBrowser(this.platformId)) {
      var ua = navigator.userAgent.toLowerCase();
      var windows8 = ua.indexOf("windows nt 6.2") > -1
      var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
      var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
      var android = ua.indexOf("android") > -1;
      var msie = ua.indexOf("msie") > -1;
      if (mobile && iPhone) return ('iPhone');
      else if (mobile && android) return ('android');
      else if (windows8) return ("windows8")
    }
  }
  loadAnalytic(trackingID) {
    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);
    let gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;
    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  // @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
  //   event.returnValue = false;
  // }
}
